import React, { useEffect, useState } from 'react';
import {
  Flex,
  Switch,
  Icon,
  IconButton,
  HStack,
  Text,
  MenuList,
  MenuItem,
  useToast,
} from '@chakra-ui/react';
import { FiArrowDown } from 'react-icons/all';
import { FiArrowUp } from 'react-icons/fi';
import { Parametros, ParametrosView } from '~/types';
import { Menu } from '~/components';
import { InputNewValue } from '~/components/InputNewValue';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const OrderControl: React.VFC<{
  parametros: any[];
  salvarMudanca: (lista: Parametros[]) => void;
  editando?: (editando: boolean) => void;
  carregando?: boolean;
}> = ({ parametros, salvarMudanca, editando, carregando = false }) => {
  const [parametrosOrdenados, setParametrosOrdenados] = useState<
    ParametrosView[]
  >([]);
  const toast = useToast();

  useEffect(() => {
    const formatarParametros = parametros.map(parametro => ({
      ...parametro,
      editando: false,
    }));
    setParametrosOrdenados(formatarParametros);
  }, [parametros]);

  const subir = (index: number) => {
    if (index === 0) return;
    const aux = parametrosOrdenados[index - 1];
    parametrosOrdenados[index - 1] = parametrosOrdenados[index];
    parametrosOrdenados[index] = aux;
    setParametrosOrdenados([...parametrosOrdenados]);
    salvarMudanca(parametrosOrdenados);
  };

  const descer = (index: number) => {
    if (index === parametrosOrdenados.length - 1) return;
    const aux = parametrosOrdenados[index + 1];
    parametrosOrdenados[index + 1] = parametrosOrdenados[index];
    parametrosOrdenados[index] = aux;
    setParametrosOrdenados([...parametrosOrdenados]);
    salvarMudanca(parametrosOrdenados);
  };

  const descerDesabilitado = (index: number) => {
    if (index === parametrosOrdenados.length - 1) return true;
    return false;
  };

  const subirDesabilitado = (index: number) => {
    if (index === 0) return true;
    return false;
  };

  const changeStatus = (index: number) => {
    parametrosOrdenados[index].status = !parametrosOrdenados[index].status;
    setParametrosOrdenados([...parametrosOrdenados]);
    salvarMudanca(parametrosOrdenados);
  };

  const editar = (index: number) => {
    parametrosOrdenados[index].editando = !parametrosOrdenados[index].editando;
    setParametrosOrdenados([...parametrosOrdenados]);
    editando?.(parametrosOrdenados[index].editando);
  };

  const remover = (index: number) => {
    parametrosOrdenados.splice(index, 1);
    setParametrosOrdenados([...parametrosOrdenados]);
    salvarMudanca(parametrosOrdenados);
  };

  const estaEditando = parametrosOrdenados.some(
    parametro => parametro.editando,
  );

  const salvarEdicao = (index: number, valor: string) => {
    if (
      parametrosOrdenados[index].nome !== valor &&
      parametrosOrdenados.some(it => it.nome === valor)
    ) {
      toast({
        title: 'Erro ao adicionar parâmetro',
        description: 'Já existe um parâmetro com esse nome',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return;
    }
    parametrosOrdenados[index].nome = valor;
    setParametrosOrdenados([...parametrosOrdenados]);
    salvarMudanca(parametrosOrdenados);
    editar(index);
  };

  return parametrosOrdenados.length ? (
    parametrosOrdenados?.map((parametro: ParametrosView, index: number) => (
      <Flex flexDir="row" key={parametro.nome} w="100%">
        <HStack w="100%" justifyContent="space-between">
          <HStack w="80%">
            <IconButton
              icon={<Icon fontWeight="bolder" fontSize="16" as={FiArrowUp} />}
              aria-label=""
              onClick={e => {
                subir(index);
              }}
              isDisabled={
                subirDesabilitado(index) || estaEditando || carregando
              }
            />
            <IconButton
              icon={<Icon fontWeight="bolder" fontSize="16" as={FiArrowDown} />}
              aria-label=""
              onClick={e => {
                descer(index);
              }}
              isDisabled={
                descerDesabilitado(index) || estaEditando || carregando
              }
            />
            {parametro.editando && !carregando ? (
              <InputNewValue
                salvarValor={e => salvarEdicao(index, e)}
                esconderInput={() => editar(index)}
                value={parametro.nome}
                limiteCaracteres={50}
              />
            ) : (
              <p>{parametro.nome}</p>
            )}
          </HStack>
          <HStack>
            <Switch
              id="status"
              size="lg"
              colorScheme="green"
              isChecked={parametro.status}
              onChange={e => changeStatus(index)}
              isDisabled={estaEditando || carregando}
            />
            <Menu isDisabled={estaEditando || carregando}>
              <MenuList>
                <MenuItem onClick={() => editar(index)}>Editar</MenuItem>
                <MenuItem onClick={() => remover(index)}>Remover</MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </HStack>
      </Flex>
    ))
  ) : (
    <>
      <Text textAlign="center"> Não há parâmetros para tipo selecionado. </Text>
    </>
  );
};
